
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_60808_5494)"}},[_c('path',{attrs:{"d":"M2.667 8.875a1.25 1.25 0 012.165-1.25L6 9.5V2.75a1.25 1.25 0 012.5 0v3.5a1.25 1.25 0 012.5 0v1a1.25 1.25 0 012.5 0V9.5a5 5 0 01-5 5c-2.761 0-3.488-1.5-5.832-5.625z","stroke":"#4A4A4A","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_60808_5494"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    